import { ReactKeycloakProvider } from '@react-keycloak/web';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import ReactDOM from 'react-dom';
import keycloak from './keycloak';
import { DefaultRouter } from './routes';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';

import { MantineProvider } from '@mantine/core';

declare global {
    interface Window {
        heap: {
            identify: (id: string) => void;
            addUserProperties: (data: {}) => void;
        };
        rewardful?: (action: string, options: {}) => void;
        Rewardful?: {};
        HW_config: { selector: string; account: string };
        Headway: {};
        $crisp: (string | boolean | string[])[][];
        Reform: (id: string, args: {}) => void;
        CRISP_WEBSITE_ID: string;
        pricewell?: {
            checkout: (
                pageId: string,
                planId?: string,
                settings?: {
                    quantity?: number;
                    coupon?: string;
                    email?: string;
                    stripeId?: string;
                    chargeLater?: boolean;
                }
            ) => Promise<void>;
            customerPortal: (id: string, config: {}) => void;
            track: (action: string, type: string, id: string, label: string) => void;
            features: (
                id: string,
                config: {}
            ) => Promise<{ plan: string; features: { id: string; name: string; slug: string }[] }>;
        };
        pricewellSnippet?: { initCustomerPortal?: () => {}; init?: () => void };
    }
}

const eventLogger = (event: unknown, error: unknown) => {
    //console.log('onKeycloakEvent', event, error);
};

const tokenLogger = (tokens: unknown) => {
    //console.log('onKeycloakTokens', tokens);
};

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        allowUrls: [/https?:\/\/(.*\.)?pricewell\.io/],
        dsn: 'https://1776bac1b55d48bb9eba24e3a29d6734@o505994.ingest.sentry.io/5595232',
        autoSessionTracking: true,
        integrations: [Sentry.browserTracingIntegration, Sentry.feedbackAsyncIntegration],
        environment: process.env.NODE_ENV,
        tracesSampleRate: 0.1,
    });
}

ReactDOM.render(
    <React.StrictMode>
        <ReactKeycloakProvider authClient={keycloak} onEvent={eventLogger} onTokens={tokenLogger}>
            <MantineProvider withCSSVariables withGlobalStyles withNormalizeCSS theme={{ colorScheme: 'light' }}>
                <DefaultRouter />
            </MantineProvider>
        </ReactKeycloakProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
